import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Search } from "lucide-react";
import { API } from "@/auth";
import useSeo from "@/seo";

export default function DreamNumbersPublic() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const nav = useNavigate();

  useSeo({
    title: "Dream Numbers | Morning Sunday Teer",
    description: "Search dream numbers for Shillong Morning Teer — find Direct, House and Ending values linked to your dream.",
    path: "/dream-numbers",
  });

  useEffect(() => {
    document.title = "Dream Numbers | Morning Sunday Teer";
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(true);
      const url = query.trim()
        ? `${API}/dream-numbers?q=${encodeURIComponent(query.trim())}`
        : `${API}/dream-numbers`;
      axios.get(url).then((r) => setRows(r.data || [])).finally(() => setLoading(false));
    }, 200);
    return () => clearTimeout(t);
  }, [query]);

  return (
    <div className="dn-shell" data-testid="dream-numbers-page">
      <div className="dn-container">
        <button className="pr-back" data-testid="dn-back-button" onClick={() => nav("/")}>
          <ArrowLeft /> Back
        </button>

        <h1 className="pr-title" data-testid="dn-heading">Dream Numbers</h1>
        <p className="pr-sub">Find lucky numbers connected to what you saw in your dream.</p>

        <div className="pr-search">
          <Search size={18} />
          <input
            data-testid="dn-search-input"
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search a dream (e.g. Snake, Money, Travel)"
            aria-label="Search dream numbers"
          />
        </div>

        <div className="dn-card">
          <div className="dn-head" data-testid="dn-table-head">
            <div>Sl.No</div>
            <div>Dream</div>
            <div>Direct</div>
            <div>House</div>
            <div>Ending</div>
          </div>
          {loading ? (
            <div className="pr-empty" data-testid="dn-loading">Loading…</div>
          ) : rows.length === 0 ? (
            <div className="pr-empty" data-testid="dn-empty">No dream matches your search.</div>
          ) : (
            rows.map((r, i) => (
              <div className="dn-row" key={r.id} data-testid={`dn-row-${r.id}`}>
                <div className="dn-sl">{i + 1}</div>
                <div className="dn-dream" data-testid={`dn-dream-${r.id}`}>{r.dream}</div>
                <div className="dn-vals" data-testid={`dn-direct-${r.id}`}>{r.direct || "—"}</div>
                <div className="dn-vals" data-testid={`dn-house-${r.id}`}>{r.house || "—"}</div>
                <div className="dn-vals" data-testid={`dn-ending-${r.id}`}>{r.ending || "—"}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
